import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 8px;
  }
`;

export const GroupImg = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    max-width: 600px;
  }
`;

export const Button = styled.button`
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.grey.white};

  svg {
    width: 28px;
    margin-bottom: 5px;
    color: ${({ theme }) => theme.colors.grey.white};

    path {
      stroke-width: 2.5px;
    }
  }
`;
